export enum EventStatus {
  approved = 'approved',
  rejected = 'rejected',
}
